import moment from "moment";

export const comparePeriodStartDateAscending = (a, b) => moment(a.Start).isAfter(moment(b.Start) ? -1 : 1);